import type { HTMLAttributes, JSX } from "preact";
import { lazy } from "preact/compat";
import { useEffect, useRef } from "preact/hooks";

interface Props {
    options: Highcharts.Options;
    containerProps?: HTMLAttributes<HTMLDivElement>;
}

export const HighchartsReactLazy = lazy(async () => {
    const { Highcharts } = await import("./HighchartsBundle");

    function HighchartsReactLazy({
        options,
        containerProps,
    }: Props): JSX.Element {
        const containerRef = useRef<HTMLDivElement>(null);
        const chartRef = useRef<Highcharts.Chart | null>(null);

        useEffect(() => {
            const container = containerRef.current;

            if (container == null) {
                return;
            }

            if (chartRef.current == null) {
                chartRef.current = Highcharts.chart(container, options);
            } else {
                // false = Disable redraw animation
                chartRef.current.update(options, true, true, false);
            }
        }, [options]);

        useEffect(() => {
            return () => {
                chartRef.current?.destroy();
                chartRef.current = null;
            };
        }, []);

        return <div {...containerProps} ref={containerRef} />;
    }

    HighchartsReactLazy.displayName = "HighchartsReactLazy";

    return { default: HighchartsReactLazy };
});
